import React from 'react';
import { AssetCategory, WizardState } from '../../../hooks/useZakatWizard';
import { Card } from '../../ui/Card';
import { Wallet, TrendingUp, PiggyBank, Coins, HandCoins, Building2 } from 'lucide-react';
interface WelcomeStepProps {
  state: WizardState;
  updateState: (updates: Partial<WizardState>) => void;
}
export function WelcomeStep({
  state,
  updateState
}: WelcomeStepProps) {
  const toggleCategory = (category: AssetCategory) => {
    const current = state.selectedCategories;
    const updated = current.includes(category) ? current.filter(c => c !== category) : [...current, category];
    updateState({
      selectedCategories: updated
    });
  };
  const categories: {
    id: AssetCategory;
    label: string;
    icon: React.ReactNode;
    desc: string;
  }[] = [{
    id: 'cash',
    label: 'Cash & Bank Accounts',
    icon: <Wallet className="h-6 w-6" data-id="element-555" />,
    desc: 'Cash on hand, checking, savings, PayPal, etc.'
  }, {
    id: 'investments',
    label: 'Investments',
    icon: <TrendingUp className="h-6 w-6" data-id="element-556" />,
    desc: 'Stocks, ETFs, Mutual Funds, Crypto, Bonds'
  }, {
    id: 'retirement',
    label: 'Retirement Accounts',
    icon: <PiggyBank className="h-6 w-6" data-id="element-557" />,
    desc: '401(k), IRA, Roth IRA, HSA'
  }, {
    id: 'goldSilver',
    label: 'Gold & Silver',
    icon: <Coins className="h-6 w-6" data-id="element-558" />,
    desc: 'Jewelry, bullion, coins (gold or silver only)'
  }, {
    id: 'moneyOwedToMe',
    label: 'Money Owed to Me',
    icon: <HandCoins className="h-6 w-6" data-id="element-559" />,
    desc: 'Personal loans given, expected payments'
  }, {
    id: 'business',
    label: 'Business Assets',
    icon: <Building2 className="h-6 w-6" data-id="element-560" />,
    desc: 'Inventory, business cash, receivables'
  }];
  return <div className="space-y-6" data-id="element-561">
      <div className="text-center mb-8" data-id="element-562">
        <h2 className="text-2xl font-bold text-gray-900 font-serif mb-2" data-id="element-563">
          What do you own?
        </h2>
        <p className="text-gray-600" data-id="element-564">
          Select the types of assets you have. Don't worry if you're
          unsure—select it anyway and we'll explain what counts in the next
          steps.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-565">
        {categories.map(cat => {
        const isSelected = state.selectedCategories.includes(cat.id);
        return <div key={cat.id} onClick={() => toggleCategory(cat.id)} className={`
                relative p-6 rounded-xl border-2 cursor-pointer transition-all duration-200
                ${isSelected ? 'border-[#2D9596] bg-teal-50/30 shadow-sm' : 'border-gray-100 bg-white hover:border-gray-200 hover:bg-gray-50'}
              `} data-id="element-566">
              <div className="flex items-start gap-4" data-id="element-567">
                <div className={`
                  p-3 rounded-lg transition-colors
                  ${isSelected ? 'bg-[#2D9596] text-white' : 'bg-gray-100 text-gray-500'}
                `} data-id="element-568">
                  {cat.icon}
                </div>
                <div className="flex-1" data-id="element-569">
                  <h3 className={`font-semibold mb-1 ${isSelected ? 'text-[#2D9596]' : 'text-gray-900'}`} data-id="element-570">
                    {cat.label}
                  </h3>
                  <p className="text-sm text-gray-500 leading-relaxed" data-id="element-571">
                    {cat.desc}
                  </p>
                </div>
                <div className={`
                  h-6 w-6 rounded-full border-2 flex items-center justify-center
                  ${isSelected ? 'border-[#2D9596] bg-[#2D9596]' : 'border-gray-300'}
                `} data-id="element-572">
                  {isSelected && <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-573">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-574" />
                    </svg>}
                </div>
              </div>
            </div>;
      })}
      </div>
    </div>;
}